import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../diccionarios/moduloVMI';
import {ArticuloModel} from '../../models/vmi-articuloModel';

@Injectable({
  providedIn: 'root'
})
export class VmiArticulosService {

  diccionarioUrl: any = {};
  url: string;

  constructor(
    private _commom: CommonService,
    private _utils: UtilsService
  ) {
    this.url = this._utils.getVmi();
    this.diccionarioUrl = moduloVMI.url.administracion;
  }

  getAll(): Observable<ArticuloModel[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.articulos);
  }

  create(innObj: ArticuloModel): Observable<any> {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioUrl.articulos, innObj);
  }

  edit(innObj: ArticuloModel): Observable<any> {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioUrl.articulos, innObj);
  }

  delete(innIdObj: number): Observable<any> {
    return this._commom.peticionDeleteConHeader(this.url + this.diccionarioUrl.articulos + `/${innIdObj}`);
  }

  getArticuloByCliente(innIdClienete: string) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.articulos + `/cliente/${innIdClienete}`);
  }
}
